import supplyModule from "./supplyModule"
import supplyView from "./supply.html"

supplyModule.directive("nlgSupply", [() => {
    return {
        restrict: "E",
        template: supplyView,
        controller: [function () {

        }]
    }
}])